// extracted by mini-css-extract-plugin
export default {"wrapper":"TxTip_wrapper__oChJu","wrapperSelected":"TxTip_wrapperSelected__mLxIp","dataRow":"TxTip_dataRow__0aC6g","popoverRoot":"TxTip_popoverRoot__WQzFT"};